import { motion } from "framer-motion";
import { Send, BellRing } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { TELEGRAM_URL } from "@/config";

const NOTIFS = [
    { body: "Smart TV 4K 50\" −33% · €299,99", time: "ora" },
    { body: "Cuffie Wireless ANC −50% · €39,99", time: "1 min" },
    { body: "Robot Vacuum −36% · €159,99", time: "7 min" },
];

export default function TelegramCta() {
    return (
        <section
            id="telegram"
            data-testid="telegram-cta"
            className="relative overflow-hidden bg-gradient-to-b from-telegram-deep via-telegram to-telegram-glow py-20 sm:py-28"
        >
            <Send strokeWidth={1} className="pointer-events-none absolute -right-16 -top-16 h-80 w-80 rotate-12 text-white/10" />
            <Send strokeWidth={1} className="pointer-events-none absolute -left-20 bottom-0 h-64 w-64 -rotate-12 text-white/5" />
            <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(255,255,255,0.16),transparent_55%)]" />

            <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-4 sm:px-6 lg:grid-cols-[1.1fr_0.9fr] lg:px-8">
                <div className="text-center lg:text-left">
                    <Reveal>
                        <span
                            data-testid="telegram-eyebrow"
                            className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-white ring-1 ring-white/25 backdrop-blur"
                        >
                            <BellRing className="h-3.5 w-3.5" />
                            Notifiche attive
                        </span>
                    </Reveal>
                    <Reveal delay={0.08}>
                        <h2 className="mx-auto mt-6 max-w-xl font-display text-3xl font-semibold leading-[1.06] tracking-tight text-white sm:text-5xl lg:mx-0">
                            Vuoi smettere di perdere le offerte migliori?
                        </h2>
                    </Reveal>
                    <Reveal delay={0.16}>
                        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-white/85 sm:text-lg lg:mx-0">
                            Entra gratuitamente in Sconti Incredibili e lascia che siamo noi a cercare le
                            occasioni per te.
                        </p>
                    </Reveal>
                    <Reveal delay={0.24}>
                        <a
                            href={TELEGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="telegram-banner-cta"
                            className="btn-shine mt-9 inline-flex items-center gap-3 rounded-full bg-white px-8 py-4 font-display text-sm font-semibold uppercase tracking-wide text-ink shadow-[0_20px_50px_-12px_rgba(11,18,32,0.45)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_28px_60px_-14px_rgba(11,18,32,0.55)] sm:px-10 sm:py-[18px] sm:text-base"
                        >
                            <span aria-hidden>🚀</span>
                            <span>ENTRA SU TELEGRAM</span>
                        </a>
                    </Reveal>
                    <Reveal delay={0.3}>
                        <p className="mt-5 font-mono text-[11px] uppercase tracking-[0.2em] text-white/70">
                            Gratis · Nessun abbonamento
                        </p>
                    </Reveal>
                </div>

                {/* Phone with looping notifications */}
                <div className="relative mx-auto w-full max-w-[330px]">
                    <div className="rounded-[2.4rem] bg-ink p-2.5 shadow-[0_40px_90px_-25px_rgba(11,18,32,0.75)] ring-1 ring-white/20">
                        <div className="relative overflow-hidden rounded-[2rem] bg-slate-900">
                            <div className="relative flex items-center justify-between px-6 pt-4">
                                <span className="text-[10px] font-semibold text-white/70">9:41</span>
                                <div className="absolute left-1/2 top-2 h-[16px] w-20 -translate-x-1/2 rounded-full bg-ink" />
                                <span className="text-[10px] tracking-widest text-white/50">●●●</span>
                            </div>

                            <div className="px-4 pb-7 pt-6" data-testid="telegram-notifications">
                                <p className="text-center font-mono text-[10px] uppercase tracking-[0.22em] text-white/40">
                                    Notifiche di oggi
                                </p>
                                <div className="mt-4 space-y-3">
                                    {NOTIFS.map((n, i) => (
                                        <motion.div
                                            key={i}
                                            initial={{ opacity: 0, y: -30 }}
                                            animate={{
                                                opacity: [0, 1, 1, 0],
                                                y: [-30, 0, 0, 14],
                                            }}
                                            transition={{
                                                duration: 6.5,
                                                times: [0, 0.12, 0.88, 1],
                                                delay: i * 0.75,
                                                repeat: Infinity,
                                                repeatDelay: 0.4,
                                                ease: "easeOut",
                                            }}
                                            data-testid={`telegram-notification-${i}`}
                                            className="flex items-start gap-3 rounded-2xl bg-white/95 p-3.5 shadow-[0_14px_35px_-12px_rgba(11,18,32,0.4)] backdrop-blur"
                                        >
                                            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-telegram-glow to-telegram-dark">
                                                <Send className="h-4 w-4 text-white" />
                                            </div>
                                            <div className="min-w-0 flex-1">
                                                <div className="flex items-center justify-between gap-2">
                                                    <span className="truncate text-xs font-bold text-ink">
                                                        Sconti Incredibili
                                                    </span>
                                                    <span className="shrink-0 text-[10px] text-slate-400">{n.time}</span>
                                                </div>
                                                <p className="mt-0.5 truncate text-xs text-slate-600">{n.body}</p>
                                            </div>
                                        </motion.div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
